// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
require('../internals/define-well-known-symbol')('patternMatch');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/esnext.symbol.pattern-match.js
// module id = 298
// module chunks = 1